export default __webpack_public_path__ + "static/SR USA - Liquid Caramel Color HACCP - Statement-8319c9d2a4b9131a2999ae69eb0ef832.pdf";